// extracted by mini-css-extract-plugin
var _1 = "CompanyName-moduleCompanyName__hcDAC";
var _2 = "CompanyName-moduletext__TaONI";
export { _1 as "CompanyName", _2 as "text" }
